module.exports = __webpack_public_path__ + "img/1513423038.b6f3158a.jpg";